import { getEnv } from "../config/runtimeEnv";

export const api = getEnv("REACT_APP_API_URL");
